import { WorkspaceProductDTO } from 'features/product/api/types/workspaceProductDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const WORKSPACE_PRODUCT_FRAGMENT: TypedDocumentNode<WorkspaceProductDTO> = gql`
  fragment WorkspaceProductFragment on WorkspaceProduct {
    createdAt
    from
    id
    product
    status
    to
    updatedAt
    workspace {
      id
      name
    }
  }
`
